<template>
	<AppButton
		variant="ghost"
		class="bg-white border rounded-sm hover:bg-purple-50 disabled:hover:bg-white disabled:brightness-90"
		:class="outerClasses"
	>
		<div class="flex gap-2.5 items-center">
			<AppIconContained v-if="icon" :icon size="md" :palette />
			<p class="text-sm" :class="labelClasses">{{ label }}</p>
		</div>
	</AppButton>
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface Props {
	icon?: string;
	active?: boolean;
	label: string;
}

const props = withDefaults(defineProps<Props>(), {
	active: false,
	icon: undefined,
});

const palette = computed(() => (props.active ? "purple" : "gray"));

const outerClasses = computed(() => ({
	"border-accent-primary": palette.value === "purple",
}));

const labelClasses = computed(() => ({
	"text-accent-primary": palette.value === "purple",
}));
</script>
